module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Snow2-00725fa45ba171984d6c4fc0ba85b241.svg";